import o,{css as t}from"styled-components";const p=o.div`
  margin-top: 10px;
  padding: 14px 16px 12px;
  background-color: #fff;
  box-shadow: rgb(0 0 0 / 20%) 0px 1px;
`,r=t`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -1px;
    height: 1px;
    left: 0;
    background-color: rgba(0, 0, 0, 0.2);
    width: calc(100% + 16px);
  }
`;export{r as Divider,p as Wrapper};
//# sourceMappingURL=styled.js.map
